import { render, staticRenderFns } from "./LimitesVendedor.vue?vue&type=template&id=b72f359a&scoped=true"
import script from "./LimitesVendedor.vue?vue&type=script&lang=js"
export * from "./LimitesVendedor.vue?vue&type=script&lang=js"
import style0 from "./LimitesVendedor.vue?vue&type=style&index=0&id=b72f359a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72f359a",
  null
  
)

export default component.exports